import { Pipe, PipeTransform } from '@angular/core';

import { Notification } from "../notification";

@Pipe({
  name: 'unreadNotifications'
})
export class UnreadNotificationsPipe implements PipeTransform {

	transform(notifications: Notification[]) {
		return notifications.filter(notification => notification.Unread);
	}
}


// WEBPACK FOOTER //
// ./src/app/navigation/pipes/unread-notifications.pipe.ts